
import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import CustomLink from "@gc-npm/components.custom-link";
import IconGlyph from "@gc-npm/components.icon-glyph";
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';

import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import { COLORS } from "@gc-npm/utils.enums.colors";

const COMPONENT_NAME = "RetenModal";
const PHONE_NUMBER = "900201013";

const C2CRetentionModalV2 = ({
  title = "Confirmar baja",
  data,
  description = "Para asegurarnos de que tu baja se realiza correctamente, llama gratis al ",
componentProduct
}) => {
  debugger;
  const dispatch = useDispatch();
  const {
    productName,
    promotions,
  } = data || {};
  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: 'imprime-modal-retencion-900',
    componentProduct,
    componentVariation: `baja_${productName || 'no-recuperado'}`,
  };

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: 'print-success',
    });
  }, []);

  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: "",
      })
    );
  };

  return (
    <div className="C2CRetentionModal">
      <div className="C2CRetentionModal_Header">
        <TextInfo
          text={title}
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.MOVISTAR_BLACK}
          size={TEXT_SIZE.T5}
          fontType={TEXT_FONT_WEIGHT.BOLD}
        />
        <div className="C2CRetentionModal_Close">
          <CustomLink
            ariaLabel="Cerrar"
            taggingInfo={{ ...taggingInfo, componentContent: "Cerrar" }}
            onClick={onCloseModal}
          >
            <IconGlyph
              id="Cerrar"
              height={14}
              width={14}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
          </CustomLink>
        </div>
      </div>
      <div className="C2CRetentionModal_Content">
        <div className="C2CRetentionModal_ContentBody">
          <span className="C2CRetentionModal_Description">{description}</span>
          <span className="C2CRetentionModal_PhoneWrapper">
            <CustomLink
              ariaLabel={`Llamar al ${PHONE_NUMBER}`}
              taggingInfo={taggingInfo}
              href={`tel:+34${PHONE_NUMBER}`}
              className="C2CRetentionModal_PhoneLink SCX-telefono-href"
            >
              <TextInfo
                className="C2CRetentionModal_Phone"
                text={PHONE_NUMBER}
                kind={TEXT_KIND.SPAN}
                color={TEXT_COLOR.BLUE_A}
                size={TEXT_SIZE.T5}
                fontType={TEXT_FONT_WEIGHT.BOLD}
              />
            </CustomLink>
          </span>
        </div>
      </div>
      <style jsx>
        {`
          .C2CRetentionModal {
            background-color: ${COLORS.movistarWhite};
            padding: 1.5rem;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            
            width: 70vw;
            max-width: 680px;
            min-height: 22dvh;
            max-height: 80dvh;
            overflow: hidden;

            &_Header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              gap: 1rem;
            }

            &_Close {
              display: flex;
              flex-shrink: 0;
            }

            &_Content {
              display: flex;
              align-items: center;
              flex: 1;
              overflow-y: auto;
              color: ${COLORS.grey600};

              :global(a) {
                display: inline;
              }
            }

            &_ContentBody {
              width: 100%;
            }

            &_Description {
              display: inline;
            }

            &_PhoneLink {
              display: inline;
            }

            &_PhoneWrapper {
              display: inline;
            }

            :global(.C2CRetentionModal_Phone) {
              white-space: nowrap;
              display: inline;
            }
          }

          @media (max-width: 768px) {
            .C2CRetentionModal {
              width: 100vw;
              border-radius: 1rem 1rem 0 0;
              min-height: auto;
              gap: 1.5rem;

              &_Content {
                display: block;
                flex: none;
              }

              &_ContentBody {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
              }

              &_Description {
                display: block;
              }

              &_PhoneWrapper {
                display: block;
                width: 100%;
                text-align: center;
              }

              :global(a.C2CRetentionModal_PhoneLink) {
                display: inline-block;
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default C2CRetentionModalV2;
